function data_get() {
           $('.cart_page_spinner').addClass('active_loaders'); 
   $('.drawer__inner').addClass('active_loader'); 

$.ajax({
    url: "/cart",
    success: function (data) {
      setTimeout(function(){

      $("cart-drawer-items .csapp_discount_total_wrapper").html("");
        var cart1 = $(data).find("cart-drawer-items .csapp_discount_total_wrapper");
      var cart2 = $(data).find('cbb-shipping-rates-calculator-cart-subtotal span#cbb-shipping-rates-calculator-cart-subtotal span');
        $("cart-drawer-items .csapp_discount_total_wrapper").html(cart1);
      $('cbb-shipping-rates-calculator-cart-subtotal span#cbb-shipping-rates-calculator-cart-subtotal span').html(cart2);
       $("#CartDrawer-CartItems").load(" .drawer__cart-items-wrapper");
            document.querySelectorAll("#CartDrawer-CartItems .cart-item").forEach((item) => {
	item.querySelectorAll(".product-option dt").forEach((subitem) => {
		if (subitem.textContent.includes("CustomisationID")) {
			item.querySelector("dl").remove();
			item.querySelector(".cart-item__quantity").remove();

			let custTitle = document.createElement("div");
			custTitle.classList.add("custTitle");
			custTitle.textContent = `Customised product`;
			item.querySelector(".cart-item__details").prepend(custTitle);

			let custText = document.createElement("div");
			custText.classList.add("custText");
			custText.innerHTML = `
                Please check <a href="/cart">cart</a> for details
            `;
			item.querySelector(".cart-item__details").append(custText);
		}
	});
});
             $('.cart_page_spinner').removeClass('active_loaders'); 
        $('.drawer__inner').removeClass('active_loader');
      

              },3500);
     
       
       
       }
   
  
});

}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.querySelector('form').classList.contains("pers-product-form")){
        
      }
      else{
         this.form.querySelector('[name=id]').disabled = false;
      }
    
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
     $.ajax({
    url: "/cart",
    success: function (data) {
      var total_pro = $('table.cart-items tbody tr').length;
     var gift_pro = $('table.cart-items tr.cart-item.free-packing_product').length;
      var gift_pro_id = $('table.cart-items tr.cart-item.free-packing_product').attr('data-id');
    
     if(gift_pro == 1 && gift_pro_id == '40558809579587') {
       $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
    id: '40558809579587',
    quantity: 1,
    },
    }).then((data) => {
  data_get();
  });
      }
      else if(gift_pro == 1 && gift_pro_id == '40160598491203') {
       $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
    id: '40558809579587',
    quantity: 0,
    },
    }).then((data) => {
  data_get();
  });
      }
       else if(gift_pro == 1 && gift_pro_id == '40160599310403') {
       $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
    id: '40558809579587',
    quantity: 0,
    },
    }).then((data) => {
  data_get();
  });
      }
      else {
        data_get();
      }
    }
     });
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
   
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
     
      }
      config.body = formData;
     
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
         
          if (response.status) {
             
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            
            return;
           
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
            
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
            
          } else {
           
            
            
           
             this.cart.renderContents(response);
        
         
           
           }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
         
        
          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
